module.exports = __webpack_public_path__ + "static/img/rs_ct.a48d681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/rs_ct.png
// module id = W7TM
// module chunks = 1